import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
function getArrowPosition(placement) {
    if (placement.startsWith("bottom"))
        return { top: -12, transform: "rotate(-90deg)" };
    if (placement.startsWith("top"))
        return { bottom: -12, transform: "rotate(90deg)" };
    if (placement.startsWith("left"))
        return { right: -8 };
    if (placement.startsWith("right"))
        return { left: -8, transform: "rotate(180deg)" };
    return {};
}
export const FloatingArrow = React.forwardRef(function (props, forwardRef) {
    const { style, placement, x, y, className } = props;
    const positionStyle = { position: "absolute", left: x, top: y };
    const svgStyle = { ...style, ...positionStyle, ...getArrowPosition(placement) };
    return _jsx("svg", { ref: forwardRef, style: svgStyle, className: className, viewBox: "0 0 8 16", width: "8px", height: "16px", children: _jsx("path", { d: "m0 16 8-8-8-8z" }) });
});
